'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = delayedActionsFactory;

var _cachedValue = require('../../utils/cachedValue');

function delayedActionsFactory() {
    var actionsStore = (0, _cachedValue.dictionary)(function () {
        return [];
    });
    return {
        add: function add(topic, value) {
            actionsStore.getValue(topic).push(value);
        },
        get: function get(topic) {
            return actionsStore.getValue(topic);
        },
        execute: function execute(topic, action) {
            return function () {
                actionsStore.getValue(topic).forEach(function (value) {
                    action(topic, value);
                });
                actionsStore.delete(topic);
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/stub/delayedActionsFactory.js
// module id = 1862
// module chunks = 1